import styled from 'styled-components';
import HappyUncheckSvg from './happyUncheck.svg';

const HappyUncheckIcon = styled(HappyUncheckSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  cursor: pointer;
`;

export default HappyUncheckIcon;
